const heroFeatures = [
  'Automated subscription tracking',
  'Smart renewal reminders',
  'Seamless payment integration',
];

const scrollToSection = (id) => {
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: 'smooth' });
};

function HeroSection() {
  return (
    <section className="hero" id="features">
      <div className="hero-inner">
        <div className="hero-badge">
          <span className="dot" /> Subscription Management Made Simple
        </div>
        <h1>
          Your wellbeing <span className="highlight">is my profession</span>
        </h1>
        <p className="hero-subtitle">
          Focus on your training, not the logistics. Sign up quickly, view your active plan status, and handle renewals instantly — so you never miss a workout.
        </p>
        <div className="hero-actions">
          <button className="primary large" onClick={() => scrollToSection('contact')}>
            Subscribe
          </button>
          <button className="outline large" onClick={() => scrollToSection('plans')}>
            View Plans
          </button>
        </div>
        <div className="hero-features">
          {heroFeatures.map((feature) => (
            <div key={feature} className="feature-pill">
              <span className="check-icon">✔</span>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;


